import { forwardRef, useState, useEffect, useRef } from "react";
import { RequestAddComment } from "../../../../../../store/actions/analysisReportActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Warning from "../../../../../common/Warning/Warning";
import LogoIconMain from "../../../../../Icon-SVG/LogoIconMain";
import ActionButton from "../../../../../common/ActionButton/ActionButton";
import SendIcon from "../../../../../Icon-SVG/SendIcon";
import ReplyIcon from "../../../../../Icon-SVG/ReplyIcon";

//GET FILE ID IN URL
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const AddNewComment = forwardRef(function AddNewComment(
  { username = "", replyTo = "", setReplyMode = null },
  ref,
) {
  const users = useSelector((state) => state?.users.user);

  const dispatch = useDispatch();
  const [text, setText] = useState("");
  const [show, setShow] = useState();
  const [error, setError] = useState("");

  const textAreaRef = useRef();

  //SET QUERY FOR GETTING DATA ID
  let query = useQuery();

  useEffect(() => {
    if (username) {
      setText(`@${username} `);
      textAreaRef.current.focus();
    }
    return () => setText("");
  }, [username]);

  const textChange = (event) => {
    setText(event.target.value);
  };

  const addComment = () => {
    if (!text.trim()) return;

    if (text.length < 250) {
      const commentData = {
        fileId: query.get("data"),
        user: users.username,
        text: text,
        replyTo,
      };
      // The saga refreshes the comment list once the comment is stored
      dispatch(RequestAddComment(commentData));
      if (setReplyMode) {
        setReplyMode(false);
      }
      setText("");
    } else {
      setError("Please do not exceed 250 characters!");
      setShow(true);
    }
  };

  // Ctrl/Cmd + Enter sends the comment
  const keyDownHandler = (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
      event.preventDefault();
      addComment();
    }
  };

  return (
    <>
      <div className="new-comments__block" ref={ref}>
        {ref ? <div id="new-comments__block__scroll-target" /> : null}
        <LogoIconMain width={36} height={36} topa={2} />
        <textarea
          ref={textAreaRef}
          id="text"
          name="text"
          value={text}
          onChange={textChange}
          onKeyDown={keyDownHandler}
          maxLength={250}
          className="new-comments__block-textarea"
          placeholder={ref ? "Write a reply..." : "Write a comment..."}
        />
        <div className="new-comments__block-actions">
          <span
            className={`new-comments__block-counter ${
              text.length > 230 ? "new-comments__block-counter--limit" : ""
            }`}>
            {text.length}/250
          </span>
          <ActionButton
            icon={
              ref ? (
                <ReplyIcon width={12} height={12} color="currentColor" />
              ) : (
                <SendIcon width={13} height={13} color="currentColor" />
              )
            }
            onClick={addComment}
            disabled={!text.trim()}>
            {ref ? "Reply" : "Send"}
          </ActionButton>
        </div>
      </div>
      {show ? (
        <Warning
          onClickOk={() => setShow(false)}
          show={show}
          setShow={setShow}
          text={error}
          article="Warning"
          cancelDisable={true}
          textOK="Okay"
        />
      ) : null}
    </>
  );
});

export default AddNewComment;
